'use client';

import { useState, useEffect, useCallback } from 'react';
import dynamic from 'next/dynamic';

// Lazy load CommandMenu (only loads when user presses Cmd+K)
const CommandMenu = dynamic(() => import('@/components/CommandMenu'), {
  ssr: false,
});

// Lazy load KeyboardShortcutsOverlay
const KeyboardShortcutsOverlay = dynamic(
  () => import('@/components/KeyboardShortcutsOverlay'),
  { ssr: false }
);

export default function LazyCommandMenu() {
  const [showShortcuts, setShowShortcuts] = useState(false);

  // Handle Cmd+/ / Ctrl+/ to toggle shortcuts overlay
  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === '/' && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      setShowShortcuts((prev) => !prev);
    }
    // Also handle Cmd+D / Ctrl+D for quick dark mode toggle
    if (e.key === 'd' && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      // Toggle theme
      const currentTheme = localStorage.getItem('theme') || 'dark';
      const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
      localStorage.setItem('theme', newTheme);
      if (newTheme === 'dark') {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
      // Dispatch storage event for ThemeProvider to pick up
      window.dispatchEvent(new StorageEvent('storage', { key: 'theme', newValue: newTheme }));
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <>
      <CommandMenu onShowShortcuts={() => setShowShortcuts(true)} />
      <KeyboardShortcutsOverlay
        isOpen={showShortcuts}
        onClose={() => setShowShortcuts(false)}
      />
    </>
  );
}
